export default function () {
  return {
    loading: [],
    today: '',
    availableLangs: {'ro': 'Romănâ', 'en': 'English'},
    lang: localStorage.getItem('language') || 'ro'
  }
}
